import styled from "styled-components";

interface TrendVariant {
  variant: "positive" | "negative" | "neutral";
}

interface TrendSize {
  size: "small" | "medium" | "large";
}

const getGapSize = (size: string) => {
  if (size === "small") return "2px";
  if (size === "large") return "6px";
  return "4px";
};

const getMarginTop = (size: string) => {
  if (size === "small") return "4px";
  if (size === "large") return "8px";
  return "6px";
};

const getFontSize = (size: string) => {
  if (size === "small") return "var(--text-xs)";
  if (size === "large") return "var(--text-md)";
  return "var(--text-base)";
};

const getTrendColor = (variant: string) => {
  if (variant === "positive") return "var(--color-success)";
  if (variant === "negative") return "var(--color-error)";
  return "var(--color-text-secondary)";
};

export const TrendWrapper = styled.div<TrendVariant & TrendSize>`
  display: flex;
  align-items: center;
  gap: ${(props) => getGapSize(props.size)};
  margin-top: ${(props) => getMarginTop(props.size)};
`;

export const TrendIcon = styled.span<TrendVariant>`
  display: inline-flex;
  align-items: center;
  font-size: inherit;
  color: ${(props) => getTrendColor(props.variant)};
`;

export const TrendText = styled.span<TrendVariant & TrendSize>`
  font-family: "Crimson Pro", sans-serif;
  font-size: ${(props) => getFontSize(props.size)};
  font-weight: 500;
  color: ${(props) => getTrendColor(props.variant)};
  opacity: 0.9;
`;
